var DescriptionsItem = function DescriptionsItem(_ref) {
  var children = _ref.children;
  return children;
};
export default DescriptionsItem;